import React, { Component } from 'react';

import NavBar from './components/NavBar';
import Categorias from './components/Categorias';
import HeroShop from './components/HeroShop';
import AvisoAtacado from './components/AvisoAtacado';
import Descricao from './components/Descricao';
import Avaliacoes from './components/Avaliacoes';
import Recomendacoes from './components/Recomendacoes';
import Contato from './components/Contato';
import Footer from './components/Footer';

class App extends Component {
	render() {
		return (
			<div className="App">
				<div className="topBar"></div>
				<NavBar />
				<Categorias />
				<HeroShop />
				<AvisoAtacado />
				<Descricao />
				<Avaliacoes />
				<Recomendacoes />
				<Contato />
				<Footer />
			</div>
		);
	}
}

export default App;
